module.exports = __webpack_public_path__ + "media/images/notification-icon-2c7ee312b9f1f2535364e5e7ad02f860.svg";